export class StaffRatioValue {
    id: number;
    shiftScheduleId: number;
    jobTitleId: number;
    acuityCategoryId?: number;
    acuityCategoryName: string;
    staffValue?: number;
    uosCount?: number;
    createdDate?: Date;
    inactiveDate?: Date;
    shiftBlockId?: number;
}